import PropTypes from 'prop-types';

import PropTypesPresenter from '../utils/PropTypesPresenter';

const DEFAULT = 'default';
const BIRTHDAY = 'birthday';
export const RATES_TYPE = {
  default: DEFAULT,
  birthday: BIRTHDAY,
};

const ACTIVE = 'active';
const SCHEDULED = 'scheduled';
export const STATES = {
  active: ACTIVE,
  scheduled: SCHEDULED,
};

export default new PropTypesPresenter(
  {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    rate: PropTypes.number,
    rateType: PropTypes.string,
    state: PropTypes.string,
  },
  {
    rateReadable(rate) {
      return `${this.rate(rate)}%`;
    },
    typeReadable(rate) {
      const typeMap = {
        [DEFAULT]: 'Default rate',
        [BIRTHDAY]: 'Birthday perk rate',
      };
      const type = this.rateType(rate);

      return typeMap[type];
    },
    stateReadable(rate) {
      const stateMap = {
        [ACTIVE]: 'Active',
        [SCHEDULED]: 'Scheduled',
      };
      const state = this.state(rate);

      return stateMap[state];
    },
  }
);
